import React, {
  memo,
  forwardRef,
  useImperativeHandle,
  useRef,
  useMemo,
  useState,
  useCallback,
  useEffect,
} from 'react';
import { Col, Form, Input, Select } from 'antd';
import { Formik, FormikProps } from 'formik';
import * as yup from 'yup';
import { QuerySearch } from '../form/query-search';
import { BrandApi, GeneralApi, ModelApi } from '../../apis';
import { Dictionaries } from '../../interfaces';

const validationSchema = yup.object().shape({
  carBrandId: yup.string().required('Заавал оруулна'),
  carModelId: yup.string().required('Заавал оруулна'),
  manufacturerCountry: yup.string().required('Заавал оруулна'),
  steering: yup.string().required('Заавал оруулна'),
});

type FormValues = {
  carBrandId: string | undefined;
  manufacturerCountry: string | undefined;
  carModelId: string | undefined;
  steering: string | undefined;
};

type Props = {
  onSubmit: (values: any) => void;
  action: any;
};

export type BrandFormRef = {
  submitForm: () => any;
  getValues: () => any;
};

const NoneCollateralVehicleForm = memo(
  forwardRef<BrandFormRef, Props>(({ onSubmit: _onSubmit, action }, ref) => {
    const formikRef = useRef<FormikProps<FormValues>>(null);

    const [general, setGeneral] = useState<Dictionaries>();
    const loadData = useCallback(async () => {
      const res = await GeneralApi.init();
      setGeneral(res);
    }, []);

    useImperativeHandle(ref, () => ({
      submitForm: async () => {
        const validate = await formikRef.current?.submitForm();
        return validate;
      },
      getValues: () => {},
    }));

    const initialValues = useMemo(() => {
      return {
        carModelId: undefined,
        carBrandId: undefined,
        manufacturerCountry: undefined,
        steering: undefined,
        ...(action && {
          carModelId: action.carModelId,
          carBrandId: action?.carBrandId,
          manufacturerCountry: action?.manufacturerCountry,
          steering: action?.steering,
        }),
      };
    }, [action]);

    const getOption = useCallback((value?: { code?: string; name: string; id: string }[] | any) => {
      if (!value) {
        return [];
      }

      return value.map((item: any) => ({
        label: item.name,
        value: item.code ?? item.id,
      }));
    }, []);

    useEffect(() => {
      loadData();
    }, [loadData]);

    console.log('general :', general);

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={_onSubmit}
        innerRef={formikRef}
        enableReinitialize
      >
        {({ handleChange, values, errors, touched, setFieldValue }) => {
          console.log('values :', values);
          return (
            <>
              <Form layout="vertical">
                <div className="card">
                  <div className="inputContainer">
                    <div className="flex flex-row">
                      <div className="flex-1">
                        <Col flex={12}>
                          <Form.Item
                            label="Улс"
                            layout="vertical"
                            validateStatus={
                              errors.manufacturerCountry && touched.manufacturerCountry
                                ? 'error'
                                : ''
                            }
                            help={
                              errors.manufacturerCountry && touched.manufacturerCountry
                                ? errors.manufacturerCountry
                                : ('' as any)
                            }
                          >
                            <Select
                              value={values.manufacturerCountry}
                              onChange={(e) => setFieldValue('manufacturerCountry', e)}
                              options={getOption(general?.manufacturerCountries)}
                              placeholder="Улс"
                            />
                          </Form.Item>
                        </Col>

                        <Col flex={12}>
                          <Form.Item
                            label="Брэнд"
                            layout="vertical"
                            validateStatus={errors.carBrandId && touched.carBrandId ? 'error' : ''}
                            help={
                              errors.carBrandId && touched.carBrandId
                                ? errors.carBrandId
                                : ('' as any)
                            }
                          >
                            <QuerySearch
                              value={values.carBrandId}
                              onChange={(e) => setFieldValue('carBrandId', e)}
                              placeholder="Брэнд хайх"
                              showSearch
                              loadData={BrandApi.select}
                            />
                          </Form.Item>
                        </Col>
                        <Col flex={12}>
                          <Form.Item
                            label="Загвар"
                            layout="vertical"
                            validateStatus={errors.carModelId && touched.carModelId ? 'error' : ''}
                            help={
                              errors.carModelId && touched.carModelId
                                ? errors.carModelId
                                : ('' as any)
                            }
                          >
                            <QuerySearch
                              payload={{ carBrandId: values.carBrandId }}
                              value={values.carModelId}
                              onChange={(e) => setFieldValue('carModelId', e)}
                              placeholder="Загвар хайх"
                              showSearch
                              loadData={ModelApi.select}
                            />
                          </Form.Item>
                        </Col>
                        <Col flex={12}>
                          <Form.Item
                            label="Хүрд"
                            layout="vertical"
                            validateStatus={errors.carModelId && touched.carModelId ? 'error' : ''}
                            help={
                              errors.carModelId && touched.carModelId
                                ? errors.carModelId
                                : ('' as any)
                            }
                          >
                            <Select
                              value={values.steering}
                              onChange={(e) => setFieldValue('steering', e)}
                              options={getOption(general?.steeringTypes)}
                              placeholder="Хүрд"
                            />
                          </Form.Item>
                        </Col>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="h-[20px]" />
              </Form>
            </>
          );
        }}
      </Formik>
    );
  })
);

NoneCollateralVehicleForm.displayName = 'NoneCollateralVehicleForm';

export { NoneCollateralVehicleForm };
